import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from 'cityads-v3/types/reducer';
import classes from './Profile.scss';

import AvatarWithFallback from 'cityads-v3/components/ImgWithFallback/AvatarWithFallback'
import Button from '@material-ui/core/Button';
import Card from 'cityads-v3/components/Card/Card';
import EmptyResults from 'cityads-v3/components/EmptyResults/EmptyResults'
import HeadsetMicOutlinedIcon from '@material-ui/icons/HeadsetMicOutlined';
import SupportButton from 'cityads-v3/components/Buttons/SupportButton';
import Typography from '@material-ui/core/Typography';

const noavatar = require('cityads-v3/components/Header/img/noavatar.png')

type ManagerProps = {
  forwardedRef: React.ForwardedRef<Card>,
  onSupportClick?: React.MouseEventHandler
}

function Manager({
  forwardedRef,
  onSupportClick
}: ManagerProps): JSX.Element {
  const { t } = useTranslation(['main'])
  const manager = useSelector((state: RootState) => state.header.manager);

  if (!manager) {
    return (
      <EmptyResults
        className={classes.pageContainer}
        icon={<HeadsetMicOutlinedIcon />}
        emptyText={t('haveQuestion')}
        actions={
          <Button
            variant="contained"
            color="primary"
            component={SupportButton as any}
            onClick={onSupportClick}
          >{t('header.helpdesk')}</Button>
        }
        ref={forwardedRef}
      />
    );
  }

  const actions = [{
    title: t('support'),
    icon: <HeadsetMicOutlinedIcon />,
    color: 'primary',
    isPrimary: true,
    component: SupportButton,
    onClick: onSupportClick,
    target: '_blank',
    rel: 'noopener noreferrer',
    iconStyle: {
      fontSize: '20px',
      verticalAlign: 'middle',
      marginLeft: '8px'
    }
  }];

  return (
    <Card
      classes={{ root: classes.pageContainer }}
      subActions={actions}
      ref={forwardedRef}
    >
      <div className={classes.manager}>
        <div>
          <AvatarWithFallback
            src={manager.avatar}
            fallbackSrc={noavatar}
            classes={{
              root: classes.managerAvatar
            }}
          />
        </div>
        <Typography>{manager.name}</Typography>
        <Typography><a href={`mailto:${manager.email}`}>{manager.email}</a></Typography>
        {manager.skype ? <Typography>Skype: <a href={`skype:${manager.skype}?userinfo`}>{manager.skype}</a></Typography> : false}
      </div>
    </Card>
  );
}


export default forwardRef<Card>((props, ref) => <Manager {...props} forwardedRef={ref} />)
